export default __webpack_public_path__ + "static/media/malay-logo-light.ada1040c.svg";